import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true, name: 'complaintCategoryPipe'
})
export class ComplaintCategoryPipe implements PipeTransform {
  transform(id: number, categoryList: any[]): string {
    let category = categoryList.filter(x => x.complaintCategoryId == id)[0];

    return category?.name;

  }
}
